import {Component, Input, OnInit} from '@angular/core';
// import * as shape from 'd3-shape';
import {BaseResultComponent} from '../../base-result/base-result.component';
import {LinearCharResult} from '@core/class/result/linear-char-result';
import {NbWindowService} from '@nebular/theme';

@Component({
  selector: 'app-welfare-chart',
  templateUrl: './welfare-chart.component.html',
  styleUrls: ['./welfare-chart.component.css']
})
export class WelfareChartComponent extends BaseResultComponent implements OnInit {

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = false;
  showYAxisLabel = false;
  curve = null; // shape.curveStep;
  line = null;//shape.curveLinear;
  autoScale = true;
  view: any[] = [700, 400];
  dataSource: any[];
  colorScheme = {
    domain: ['#2eff0d', '#ff2800', '#596aa9']
  };

  @Input()
  title: string;

  @Input()
  useLine: boolean;

  @Input()
  linearChartResult: LinearCharResult;

  @Input()
  hide = false;

  constructor(windowService: NbWindowService) {
    super(windowService);
  }

  ngOnInit() {
    this.onResultImpl();
  }

  onResultImpl(): void {
    super.onResultImpl();

    // clear data source
    this.dataSource = [];

    if (this.linearChartResult) {

      const lineChartItems = this.linearChartResult.lineChartItems;

      if (lineChartItems != null) {
        // push objects
        lineChartItems.forEach(value => {
          this.dataSource.push(value);
        });
      }
    }

    // refresh data source
    this.dataSource = [...this.dataSource];
  }

  getLineType(useLine: boolean) {
    return useLine ? this.line : this.curve;
  }
}
